var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickRecharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.996094 9.50098C0.996094 5.96349 0.996094 4.19475 2.04889 3.01388C2.21728 2.825 2.40287 2.65033 2.60355 2.49185C3.85823 1.50098 5.73752 1.50098 9.49609 1.50098H12.4961C16.2547 1.50098 18.134 1.50098 19.3886 2.49185C19.5893 2.65033 19.7749 2.825 19.9433 3.01388C20.9961 4.19475 20.9961 5.96349 20.9961 9.50098C20.9961 13.0385 20.9961 14.8072 19.9433 15.9881C19.7749 16.1769 19.5893 16.3516 19.3886 16.5101C18.134 17.501 16.2547 17.501 12.4961 17.501H9.49609C5.73752 17.501 3.85823 17.501 2.60355 16.5101C2.40287 16.3516 2.21728 16.1769 2.04889 15.9881C0.996094 14.8072 0.996094 13.0385 0.996094 9.50098Z",
    stroke: "#14B8A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99609 13.501H10.4961",
    stroke: "#14B8A6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4961 13.501L16.9961 13.501",
    stroke: "#14B8A6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.996094 6.50098H20.9961",
    stroke: "#14B8A6",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickRecharge);
export default __webpack_public_path__ + "static/media/quickRecharge.82f9baab30afeef76226876b6eaf2ce6.svg";
export { ForwardRef as ReactComponent };